module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-body', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-left": "10px",
      "padding-top": "10px",
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "edit"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "用户名称",
      "icon": "search"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.myonkeyup.apply(null, arguments)
      },
      "change": _vm.getUsers
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.users,
      "border": "",
      "stripe": "",
      "search-def": _vm.getSearchDef(),
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange,
      "row-dblclick": _vm.rowDblclick
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "commonName",
      "label": "用户名称",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "登录名",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "role",
      "label": "角色",
      "width": "120",
      "sortable": "",
      "formatter": _vm.formatter
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "startDate",
      "label": "有效期从",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "endDate",
      "label": "有效期到",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "venderName",
      "label": "供应商",
      "min-width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "itemName",
      "label": "查询商品名称",
      "min-width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "department",
      "label": "部门",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "subVenderName",
      "label": "库位",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "编辑",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small",
            "icon": "edit"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        })], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "重设密码",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small",
            "icon": "setting"
          },
          on: {
            "click": function($event) {
              return _vm.handleReset(scope.$index, scope.row)
            }
          }
        })], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "删除",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "icon": "close"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        })], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.page,
      "page-sizes": [5, 10, 15, 20],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "width": "70%",
      "top": "8%",
      "show-close": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('div', {
    staticClass: "box-header with-border",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("新增用户                                                               ")]), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1), _vm._v(" "), _c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "120px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名称",
      "prop": "commonName",
      "required": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "70%"
    },
    model: {
      value: (_vm.addForm.commonName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "commonName", $$v)
      },
      expression: "addForm.commonName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "登录名",
      "prop": "username",
      "required": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "70%"
    },
    model: {
      value: (_vm.addForm.username),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "username", $$v)
      },
      expression: "addForm.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "password",
      "required": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "70%"
    },
    model: {
      value: (_vm.addForm.password),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "password", $$v)
      },
      expression: "addForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "有效期从"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "有效期到"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "角色",
      "required": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "remote": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addForm.role),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "role", $$v)
      },
      expression: "addForm.role"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value,
        "disabled": item.disabled
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "供应商名称"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "multiple": "",
      "filterable": "",
      "clearable": "",
      "remote": "",
      "placeholder": "请输入供应商名称",
      "remote-method": _vm.remoteMethod
    },
    model: {
      value: (_vm.addForm.venderName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "venderName", $$v)
      },
      expression: "addForm.venderName"
    }
  }, _vm._l((_vm.venders), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.label,
        "value": item.key
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品名称"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "multiple": "",
      "filterable": "",
      "clearable": "",
      "remote": "",
      "placeholder": "请输入商品名称",
      "remote-method": _vm.remoteMethod2
    },
    model: {
      value: (_vm.addForm.itemName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "itemName", $$v)
      },
      expression: "addForm.itemName"
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.label,
        "value": item.key
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "部门名称"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "remote": "",
      "placeholder": "请输入部门名称",
      "remote-method": _vm.getDepartments
    },
    model: {
      value: (_vm.addForm.department),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "department", $$v)
      },
      expression: "addForm.department"
    }
  }, _vm._l((_vm.departments), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.label,
        "value": item.key
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "业务库位"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "filterable": "",
      "multiple": "",
      "clearable": "",
      "remote": "",
      "placeholder": "请输入业务库位",
      "remote-method": _vm.getsubVenders
    },
    model: {
      value: (_vm.addForm.subVenderName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "subVenderName", $$v)
      },
      expression: "addForm.subVenderName"
    }
  }, _vm._l((_vm.subVenders), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.label,
        "value": item.key
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否显示单价金额"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "显示",
      "off-text": "隐藏"
    },
    model: {
      value: (_vm.addForm.showMoney),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "showMoney", $$v)
      },
      expression: "addForm.showMoney"
    }
  }, [_vm._v(" >")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "width": "70%",
      "top": "8%",
      "show-close": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('div', {
    staticClass: "box-header with-border",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("编辑用户")])]), _vm._v(" "), _c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "120px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名称",
      "prop": "commonName",
      "required": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "70%"
    },
    model: {
      value: (_vm.editForm.commonName),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "commonName", $$v)
      },
      expression: "editForm.commonName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "有效期从",
      "prop": "startDate"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "有效期到",
      "prop": "endDate"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "供应商名称"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "multiple": "",
      "filterable": "",
      "clearable": "",
      "remote": "",
      "placeholder": "请输入供应商名称",
      "remote-method": _vm.remoteMethod
    },
    model: {
      value: (_vm.editForm.venderName),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "venderName", $$v)
      },
      expression: "editForm.venderName"
    }
  }, _vm._l((_vm.venders), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.label,
        "value": item.key
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品名称"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "multiple": "",
      "filterable": "",
      "clearable": "",
      "remote": "",
      "placeholder": "请输入商品名称",
      "remote-method": _vm.remoteMethod2
    },
    model: {
      value: (_vm.editForm.itemName),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "itemName", $$v)
      },
      expression: "editForm.itemName"
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.label,
        "value": item.key
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "部门名称"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "remote": "",
      "placeholder": "请输入部门名称",
      "remote-method": _vm.getDepartments
    },
    model: {
      value: (_vm.editForm.department),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "department", $$v)
      },
      expression: "editForm.department"
    }
  }, _vm._l((_vm.departments), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.label,
        "value": item.key
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "业务库位"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "filterable": "",
      "multiple": "",
      "clearable": "",
      "remote": "",
      "placeholder": "请输入业务库位",
      "remote-method": _vm.getsubVenders
    },
    model: {
      value: (_vm.editForm.subVenderName),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "subVenderName", $$v)
      },
      expression: "editForm.subVenderName"
    }
  }, _vm._l((_vm.subVenders), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.label,
        "value": item.key
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否显示单价金额"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "显示",
      "off-text": "隐藏"
    },
    model: {
      value: (_vm.editForm.showMoney),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "showMoney", $$v)
      },
      expression: "editForm.showMoney"
    }
  }, [_vm._v(" >")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "width": "70%",
      "top": "8%",
      "show-close": false
    },
    model: {
      value: (_vm.resetVisible),
      callback: function($$v) {
        _vm.resetVisible = $$v
      },
      expression: "resetVisible"
    }
  }, [_c('div', {
    staticClass: "box-header with-border",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("重设密码")])]), _vm._v(" "), _c('el-form', {
    ref: "resetForm",
    attrs: {
      "model": _vm.resetForm,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "password",
      "required": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "70%"
    },
    model: {
      value: (_vm.resetForm.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.resetForm, "newPassword", $$v)
      },
      expression: "resetForm.newPassword"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.resetVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("重设")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-136ecc7a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/UserTable.vue
// module id = 1755
// module chunks = 2